module.exports = __webpack_public_path__ + "img/the3.86eda9a1.png";